function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import Icon from './Icon';
const TextUnderlineIcon = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Icon, _extends({
  "data-testid": "textUnderline",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12,16.75a7,7,0,0,1-7.17-6.69V3.8a.75.75,0,1,1,1.5,0v6.26A5.46,5.46,0,0,0,12,15.25a5.46,5.46,0,0,0,5.67-5.19V3.8a.75.75,0,0,1,1.5,0v6.26A7,7,0,0,1,12,16.75ZM21.47,20a.76.76,0,0,0-.75-.75H3.28a.75.75,0,0,0,0,1.5H20.72A.76.76,0,0,0,21.47,20Z"
})));
TextUnderlineIcon.displayName = 'TextUnderlineIcon';
TextUnderlineIcon.renderIcon = props => /*#__PURE__*/React.createElement(TextUnderlineIcon, props);
export default TextUnderlineIcon;
//# sourceMappingURL=TextUnderlineIcon.js.map